import Vue from 'vue'
// models component
import App from '@/models/App'
import Profile from '@/models/Profile'
import Feature from '@/models/Feature'
import SelectShipJob from '@/models/SelectShipJob'
import SelectShipCountry from '@/models/SelectShipCountry'
import SelectShipType from '@/models/SelectShipType'
import SelectShipSkill from '@/models/SelectShipSkill'
import SelectShipLatitude from '@/models/SelectShipLatitude'
import SelectShipLongitude from '@/models/SelectShipLongitude'

export default class Initialize {
    // Ship Management Service Initialize
    static of() {
        return Promise.resolve()
            .then(function () {
                if (!App.one()) {
                    App.of('ship')
                    if (Vue.$cookies.isKey('_t')) {
                        App.setToken(Vue.$cookies.get('_t'))
                    } else {
                        App.setToken('')
                    }
                }
            })
            .then(function () {
                return Promise.all([
                    SelectShipJob.api().fetch(),
                    SelectShipCountry.api().fetch(),
                    SelectShipType.api().fetch(),
                    SelectShipSkill.api().fetch(),
                    // SelectShipLatitude.api().fetch(),
                    // SelectShipLongitude.api().fetch(),
                    Feature.api().fetch()
                ])
            })
            // .then(function () {
            //     return SelectShipJob.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('SelectShipJob.all()', SelectShipJob.all())
            //         })
            // })
            // .then(function () {
            //     return SelectShipCountry.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('SelectShipCountry.all()', SelectShipCountry.all())
            //         })
            // })
            // .then(function () {
            //     return SelectShipType.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('SelectShipType.all()', SelectShipType.all())
            //         })
            // })
            // .then(function () {
            //     return SelectShipSkill.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('SelectShipSkill.all()', SelectShipSkill.all())
            //         })
            // })
            // .then(function () {
            //     return SelectShipLatitude.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('SelectShipLatitude.all()', SelectShipLatitude.all())
            //         })
            // })
            // .then(function () {
            //     return SelectShipLongitude.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('SelectShipLongitude.all()', SelectShipLongitude.all())
            //         })
            // })
            // .then(function () {
            //     return Feature.api()
            //         .fetch()
            //         .then(function (result) {
            //             // console.log('Feature.all()', Feature.all())
            //         })
            // })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
